// GR-3599
import { inject, Service } from '@angular/core';
import { AnalyticsService } from '@lentau/analytics/events/shared';
import { mapConfirmNumberPressedEvent } from 'analytic-events/Login/services/LoginService/events/ConfirmNumberPressed/ConfirmNumberPressed';
import { mapConfirmPhoneShownEvent } from 'analytic-events/Login/services/LoginService/events/ConfirmPhoneShown/ConfirmPhoneShown';
import { mapButtonSmsCodePressedEvent } from 'analytic-events/Login/services/LoginService/events/ButtonSmsCodePressed/ButtonSmsCodePressed';
import { mapButtonCallPressedEvent } from 'analytic-events/Login/services/LoginService/events/ButtonCallPressed/ButtonCallPressed';
import { mapNumberInstructionPressedEvent } from 'analytic-events/Login/services/LoginService/events/NumberInstructionPressed/NumberInstructionPressed';
import { mapCallBackButtonAuthPressedEvent } from 'analytic-events/Login/services/LoginService/events/CallBackButtonAuthPressed/CallBackButtonAuthPressed';
import { mapButtonChangeNumberPressedEvent } from 'analytic-events/Login/services/LoginService/events/ButtonChangeNumberPressed/ButtonChangeNumberPressed';
import {
  LoginError,
  mapLoginErrorEvent,
} from 'analytic-events/Login/services/LoginService/events/LoginError/LoginError';
import { mapEnterCodeScreenShownEvent } from 'analytic-events/Login/services/LoginService/events/EnterCodeScreenShown/EnterCodeScreenShown';
import { mapConfirmNumberStatusEvent } from 'analytic-events/Login/services/LoginService/events/ConfirmNumberStatus/ConfirmNumberStatus';
import { Platform } from 'analytic-events/Login/services/LoginService/events/ConfirmNumberStatus/Platform';
import {
  isAndroidPwaSession,
  isIosBrowserSessionWithoutPwa,
} from '@lentau/ui-kit/core/services/mini-app/pwa-session-detector.service';
import { MobileDeviceTypeEnum } from '@lentau/ui-kit/core/enums/mobile-devices-type';
import { MOBILE_OS } from '@lentau/ui-kit/core/tokens/mobile-os';
import { WINDOW } from '@lentau/ui-kit/core/tokens/window';
import { WindowEventsService } from '@lentau/ui-kit/core/services/window-events/window-events.service';

@Service()
export class AuthCallAnalyticsService {
  private analyticsService: AnalyticsService = inject(AnalyticsService);
  private mobileOs: MobileDeviceTypeEnum = inject(MOBILE_OS);
  private window: Window = inject(WINDOW);
  private windowEventsService: WindowEventsService = inject(WindowEventsService);

  public confrimNumberPressed(): void {
    this.analyticsService.pushToDataLayer(mapConfirmNumberPressedEvent({ type: 'OUTBOUND_CALL' }));
  }

  public confrimPhoneShown(): void {
    this.analyticsService.pushToDataLayer(mapConfirmPhoneShownEvent({}));
  }

  public buttonSmsCodePressed(): void {
    this.analyticsService.pushToDataLayer(mapButtonSmsCodePressedEvent({ button: 'alternative' }));
  }

  public buttonCallPressed(): void {
    this.analyticsService.pushToDataLayer(mapButtonCallPressedEvent({}));
  }

  public numberInstructionPressed(): void {
    this.analyticsService.pushToDataLayer(mapNumberInstructionPressedEvent({}));
  }

  public callBackButtonAuthPressed(): void {
    this.analyticsService.pushToDataLayer(mapCallBackButtonAuthPressedEvent({}));
  }

  public buttonChangeNumberPressed(): void {
    this.analyticsService.pushToDataLayer(mapButtonChangeNumberPressedEvent({}));
  }

  public loginError(error: LoginError): void {
    this.analyticsService.pushToDataLayer(mapLoginErrorEvent(error));
  }

  public enterCodeScreenShown(): void {
    this.analyticsService.pushToDataLayer(mapEnterCodeScreenShownEvent({ source: 'auth_call' }));
  }

  public confirmNumberStatus(response: 'error' | 'success'): void {
    let platform: Platform = 'mobile/PWA';

    if (isIosBrowserSessionWithoutPwa(this.mobileOs, this.window)) platform = 'iOS';
    else if (isAndroidPwaSession(this.mobileOs, this.window)) platform = 'Android';
    else if (this.windowEventsService.isDesktop()) platform = 'Desktop';

    this.analyticsService.pushToDataLayer(mapConfirmNumberStatusEvent({ platform, response }));
  }
}
